import * as z from 'zod'

export const PCTSchema = z.object({
  page: z.number().int().positive().optional(),
  size: z.number().int().positive().optional(),
  searchString: z.string().optional()
})
